export function isWeightBold(value) {
    if (value === undefined) {
        return false;
    }
    if (value === 'bold') {
        return true;
    }
    var weightAsNumber = parseInt(value, 10);
    return weightAsNumber >= 700;
}
//# sourceMappingURL=font.js.map